
























import Vue from 'vue';
import type { PropOptions } from 'vue';
import { distanceToNow } from '@/components/utils/core/date';
import type { Notification, Comment, Post } from '@/types/graphql';
import HeaderMenuNotificationsCardGridAvatar from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardGrid/HeaderMenuNotificationsCardGridAvatar/HeaderMenuNotificationsCardGridAvatar.vue';

export default Vue.extend({
  name: 'HeaderMenuNotificationsCardGrid',
  components: {
    HeaderMenuNotificationsCardGridAvatar,
  },
  props: {
    notification: {
      type: Object,
      required: true,
    } as PropOptions<Notification>,
    textOverflow: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    createdAgo(): string {
      if ((Date.now() - new Date(this.notification.createdAt).getTime()) / 1000 < 60) return 'Just now';

      return `${distanceToNow(new Date(this.notification.createdAt))} ago`;
    },
    contentClass(): Record<string, boolean> {
      const referenceable = this.notification.referenceable as Comment & Post;
      return {
        'header-menu-notifications-card-grid__content': true,
        'header-menu-notifications-card-grid__content--deleted': referenceable.deletedAt,
        'header-menu-notifications-card-grid__content--read': this.notification.readAt,
      };
    },
    textClass(): Record<string, boolean> {
      return {
        'header-menu-notifications-card-grid__text': true,
        'header-menu-notifications-card-grid__text--overflow': this.textOverflow,
      };
    },
  },
});
